/* Kohd letter grid: nine nodes of three letters (YZ holds two), read left to
   right, top to bottom. A letter's position in its node (1-3) is the number
   of subnode dots it adds to a trace. */

export const NODE_LETTERS = ['ABC', 'DEF', 'GHI', 'JKL', 'MNO', 'PQR', 'STU', 'VWX', 'YZ'];

export interface LetterCell {
  col: number;
  row: number;
  position: number;
}

export function letterCell(letter: string): LetterCell | undefined {
  const upper = letter.toUpperCase();
  const index = NODE_LETTERS.findIndex((node) => node.includes(upper));
  if (index < 0 || upper.length !== 1) return undefined;
  return { col: index % 3, row: Math.floor(index / 3), position: NODE_LETTERS[index].indexOf(upper) + 1 };
}
